import React from 'react';
import { Target } from 'lucide-react';

export default function Metas() {
  return (
    <div className="page-container">
      <h1 className="page-title">Metas</h1>
      <div
        className="summary-card"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4rem 2rem',
          gap: '1rem',
          color: '#6b7280',
        }}
      >
        <Target size={56} strokeWidth={1.5} style={{ opacity: 0.4 }} />
        <p style={{ fontSize: '1.2rem', fontWeight: 600 }}>Próximamente...</p>
        <p style={{ fontSize: '0.95rem' }}>Esta sección está en desarrollo.</p>
      </div>
    </div>
  );
}
